import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { useAuth } from "../../hooks/useAuth";
import "./Login.css";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        try {
            const redirectTo = await login(username, password);
            navigate(redirectTo, { replace: true });
        } catch (err) {
            setError(
                err.response?.status === 401
                    ? "Credenciales inválidas."
                    : "Error al conectar con el servidor."
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-root">
            {/* Panel izquierdo — branding */}
            <div className="login-panel-left">
                <div className="login-left-content">
                    <div className="login-brand">
                        <span className="login-brand-yappa">OSPM</span>
                    </div>
                    <div className="login-left-body">
                        <h1 className="login-hero-title">Motor de Reglas</h1>
                        <p className="login-hero-sub">
                            Gestión centralizada de reglas de negocio<br />
                            para el sistema de autorización médica.
                        </p>
                        <div className="login-features">
                            <div className="login-feature-item">
                                <span className="login-feature-icon">⚡</span>
                                <span>Evaluación en tiempo real con Drools</span>
                            </div>
                            <div className="login-feature-item">
                                <span className="login-feature-icon">📋</span>
                                <span>4 000+ reglas activas por plan de cobertura</span>
                            </div>
                            <div className="login-feature-item">
                                <span className="login-feature-icon">🔒</span>
                                <span>Acceso restringido a usuarios autorizados</span>
                            </div>
                        </div>
                    </div>
                    <p className="login-left-version">Version 1.1.1</p>
                </div>

                {/* Decoración geométrica */}
                <div className="login-deco login-deco-1" />
                <div className="login-deco login-deco-2" />
                <div className="login-deco login-deco-3" />
            </div>

            {/* Panel derecho — formulario */}
            <div className="login-panel-right">
                <div className="login-form-wrapper">
                    <div className="login-form-header">
                        <h2 className="login-form-title">Iniciar sesión</h2>
                        <p className="login-form-sub">Ingresá tus credenciales para acceder</p>
                    </div>

                    <form onSubmit={handleSubmit} className="login-form">
                        <div className="login-field">
                            <label className="login-label">Usuario</label>
                            <input
                                type="text"
                                placeholder="Ingresá tu usuario"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                                autoComplete="username"
                                className="login-input"
                            />
                        </div>

                        <div className="login-field">
                            <label className="login-label">Contraseña</label>
                            <div className="login-input-wrap">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Ingresá tu contraseña"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                    autoComplete="current-password"
                                    className="login-input login-input-pwd"
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword((v) => !v)}
                                    aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                                    className="login-eye-btn"
                                >
                                    {showPassword ? <FiEyeOff size={17} /> : <FiEye size={17} />}
                                </button>
                            </div>
                        </div>

                        {error && (
                            <div className="login-error">
                                <span className="login-error-icon">⚠</span>
                                {error}
                            </div>
                        )}

                        <button
                            type="submit"
                            disabled={loading}
                            className={`login-submit${loading ? " login-submit-loading" : ""}`}
                        >
                            {loading ? (
                                <><span className="login-spinner" /> Ingresando...</>
                            ) : "Ingresar"}
                        </button>
                    </form>

                    <p className="login-right-footer">
                        Powered by <strong>OSPM</strong> · Acceso restringido
                    </p>
                </div>
            </div>
        </div>
    );
}
